import { render, staticRenderFns } from "./support-icon.vue?vue&type=template&id=98bcfb34"
import script from "./support-icon.vue?vue&type=script&lang=js"
export * from "./support-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports